import styled from 'styled-components'

import theme from 'theme_'
import { H1, Secondary } from 'components/Typography'

export const HeaderContainer = styled.div`
  margin-bottom: 16px;
`

export const SysMonContainer = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  background-color: ${theme.colors.white};
  min-height: 75vh; // TODO a temporary solution for expanding the view across empty state
`

export const SysMonInfoLine = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  align-items: center;
  margin-top: 24px;
  max-width: 600px;
  text-align: center;
`

export const SysMonTitle = styled(H1)`
  line-height: 32px;
`

export const SysMonCaptions = styled.ul`
  display: flex;
  flex-flow: column;
  margin: 0;
  padding-left: 12px;
`

export const SysMonCaption = styled(Secondary).attrs({
  color: theme.colors.darkeyGrey,
  as: 'li',
})`
  text-align: left;
`
